import React from 'react';
import { connect } from 'react-redux';
import { AppLoader } from './appLoader/AppLoader';
import storeManager from '../store/StoreManager';
import styles from './AudioPlayerApp.scss';
import { InternetExplorerAlert } from '../components/menus/InternetExplorerAlert';
import platformDetection from '../components/utils/PlatformDetection';
import { checkKeyboardCommand } from './utils/KeyboardShortcuts';
import { setWindowSize } from '../actions/ProductionActions';
import { NoAccessAlert } from '../components/menus/NoAccessAlert';
import canvasScale from './utils/CanvasScaleUtils';
import { AudioToolPlayer } from '../components/audioTool/menus/AudioToolPlayer';
import { ExportPlayer } from '../components/audioTool/menus/ExportPlayer';
import { Loader } from './appLoader/Loader';
import audioVolumeUtils from './utils/AudioVolumeUtils';
import appParameters from './utils/AppParameters';
import modeType from '../constants/ModeConstants';
import fullScreenManager from './utils/FullScreenManager';

const AudioPlayerAppWrapper = React.createClass({
    propTypes: {
        children: React.PropTypes.object,
        appReady: React.PropTypes.bool
    },
    getInitialState() {
        return {
            originalWidth: -1,
            originalHeight: -1
        };
    },
    onScroll(e) {
        if (platformDetection.isIOSApp())
            return;

        e.preventDefault();
        e.stopPropagation();

        if (window.scrollY != 0)
            window.scrollTo(0, 0);
    },
    componentDidMount() {
        setTimeout(function() {
            try {
                if (window.parent) {
                    var iFrame = window.parent.document.getElementById('cartoonist-iframe');

                    if (iFrame && iFrame.contentWindow)
                        iFrame.contentWindow.focus();
                }
            } catch (e) {
                // error
            }
        }.bind(this), 1000);

        audioVolumeUtils.addEventListener();
        document.addEventListener('keydown', this.onKeyDown);

        if (platformDetection.isIOS() == true) {
            window.addEventListener('orientationchange', this.onResizeApp);
            window.addEventListener('scroll', this.onScroll);
        } else {
            window.addEventListener('resize', this.onResize);
        }

        const { dispatch } = this.props;
        dispatch(setWindowSize(window.innerWidth, window.innerHeight));

        this.setState({
            originalWidth: window.innerWidth,
            originalHeight: window.innerHeight
        });
    },
    componentWillUnmount() {
        audioVolumeUtils.removeEventListener();
        document.removeEventListener('keydown', this.onKeyDown);

        if (platformDetection.isIOS() == true) {
            window.removeEventListener('orientationchange', this.onResizeApp);
            window.removeEventListener('scroll', this.onScroll);
        } else {
            window.removeEventListener('resize', this.onResize);
        }
    },
    onKeyDown (e) {
        checkKeyboardCommand(e, this.props.dispatch);
    },
    onResizeApp() {
        setTimeout(this.onResize, 1 * 10);
    },
    onResize() {
        this.refreshView();
    },
    refreshView () {
        const { dispatch } = this.props;

        if (platformDetection.isIOS() == true) {
            if (window.innerWidth > window.innerHeight)
                dispatch(setWindowSize(this.state.originalWidth, this.state.originalHeight));
            else
                dispatch(setWindowSize(window.innerWidth, window.innerHeight));

            setTimeout(this.updateView, 20);
        } else {
            dispatch(setWindowSize(window.innerWidth, window.innerHeight));

            setTimeout(this.updateView, 20);
        }
    },
    updateView() {
        this.forceUpdate();
    },
    render () {
        if (platformDetection.isIE() == true) {
            if (this.props.captionsLoaded == true)
                return <InternetExplorerAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
            else
                return <AppLoader />;
        }

        if (this.props.hasNotAccess == true) {
            if (this.props.captionsLoaded == true)
                return <NoAccessAlert windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>;
            else
                return <AppLoader />;
        }

        if (!this.props.appReady) {
            return <AppLoader />;
        }

        var appStyle = {
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            background: '#F2F2F2'
        };

        const scaleProperties = canvasScale.getPrintScaleProperties(this.props.windowWidth, this.props.windowHeight);

        if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            if (fullScreenManager.isFullScreenMode())
                appStyle.background = 'black';

            return (
                <div id='app' style={appStyle} className={styles.app}>
                    <ExportPlayer dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>
                </div>
            );
        } else {
            return (
                <div id='app' style={appStyle} className={styles.app}>
                    <AudioToolPlayer dispatch={this.props.dispatch} scaleProperties={scaleProperties} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>
                    <Loader windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>
                </div>
            );
        }
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const store = storeManager.getStore();
    let windowWidth = state.production.windowWidth;
    let windowHeight = state.production.windowHeight;
    var hasNotAccess = state.menu.hasNotAccess;

    if (!(windowWidth > 0))
        windowWidth = window.innerWidth;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    if (!hasNotAccess)
        hasNotAccess = false;

    return {
        appReady: state.session.appReady && state.session.captionsLoaded,
        dispatch: store.dispatch,
        captionsLoaded: state.session.captionsLoaded,
        windowWidth,
        windowHeight,
        hasNotAccess
    };
}

export const AudioPlayerApp = connect(mapStateToProps)(AudioPlayerAppWrapper);



/** WEBPACK FOOTER **
 ** ./src/components/AudioPlayerApp.js
 **/